export const themeCategories = {
  'Suedelux/Cloth': [
    {
      title: '506 Royal Blue In Memory Series',
    },
    {
      title: '140 Mauve Tree of Life Series',
    },
    {
      title: '136 Navy Tree of Life Series',
    },
    {
      title: '315 White In Memory Series',
    },
    {
      title: '506 Royal Blue In Memory Series',
    },
    {
      title: '142 Mauve Tree of Life Series',
    },
    {
      title: '136 Navy Tree of Life Series',
    },
    {
      title: '315 White In Memory Series',
    },
    {
      title: '506 Royal Blue In Memory Series',
    },
    {
      title: '140 Mauve Tree of Life Series',
    },
    {
      title: '136 Navy Tree of Life Series',
    },
    {
      title: '315 White In Memory Series',
    },
    {
      title: '506 Royal Blue In Memory Series',
    },
    {
      title: '140 Mauve Tree of Life Series',
    },
    {
      title: '136 Navy Tree of Life Series',
    },
    {
      title: '315 White In Memory Series',
    },
    {
      title: '506 Royal Blue In Memory Series',
    },
    {
      title: '140 Mauve Tree of Life Series',
    },
    {
      title: '136 Navy Tree of Life Series',
    },
    {
      title: '315 White In Memory Series',
    },
    {
      title: '506 Royal Blue In Memory Series',
    },
    {
      title: '140 Mauve Tree of Life Series',
    },
    {
      title: '136 Navy Tree of Life Series',
    },
    {
      title: '315 White In Memory Series',
    },
    {
      title: '506 Royal Blue In Memory Series',
    },
    {
      title: '140 Mauve Tree of Life Series',
    },
    {
      title: '136 Navy Tree of Life Series',
    },
    {
      title: '315 White In Memory Series',
    },
  ],
} as const

export default themeCategories
